import i18n from 'i18next';
import ICU from 'i18next-icu';
import { initReactI18next } from 'react-i18next';
import { LANGUAGES, SOURCE_LANGUAGE, type LanguageCode } from './registry';
import { resources, NAMESPACES } from './resources';
import { resolveLanguage } from './resolve';
import { isReviewEnvironment, readStoredLanguage } from './environment';

/**
 * ICU MessageFormat (i18next-icu) is used instead of native i18next plurals:
 * Arabic has six plural categories (zero/one/two/few/many/other) and ICU keeps
 * them inside one message, which is what reviewers edit.
 */
const reviewEnv = isReviewEnvironment();
const initial = resolveLanguage({
  storedLanguage: readStoredLanguage(),
  browserLanguages: typeof navigator !== 'undefined' ? navigator.languages : [],
  reviewEnv,
}).language;

void i18n
  .use(ICU)
  .use(initReactI18next)
  .init({
    resources,
    lng: initial,
    fallbackLng: SOURCE_LANGUAGE,
    supportedLngs: Object.keys(LANGUAGES),
    ns: NAMESPACES,
    defaultNS: 'common',
    interpolation: { escapeValue: false },
    returnNull: false,
    react: { useSuspense: false },
  });

export function applyDocumentLanguage(code: LanguageCode) {
  if (typeof document === 'undefined') return;
  document.documentElement.lang = code;
  document.documentElement.dir = LANGUAGES[code].dir;
}

applyDocumentLanguage(initial);
i18n.on('languageChanged', (lng) => {
  if (lng in LANGUAGES) applyDocumentLanguage(lng as LanguageCode);
});

export default i18n;
